import { useEffect, useState } from 'react';
import { useAuth_IsImpersonatingQuery } from 'queries';

import { NotificationSeverity, showAlert } from 'utils/notification-manager';

export default function useIsImpersonating() {
  const [isImpersonating, setIsImpersonating] = useState<boolean>(false);

  const { data: isImpersonatingData } = useAuth_IsImpersonatingQuery({
    onError: (e) => {
      showAlert({
        message: 'Error checking is impersonating: ' + e.message,
        severity: NotificationSeverity.ERROR,
      });
    },
  });

  useEffect(() => {
    setIsImpersonating(isImpersonatingData?.data === true);
  }, [isImpersonatingData]);

  return isImpersonating;
}
